import { ToDoItemDescriptionWrapper, BadgeWrapper, BadgeWrapperForNonList } from '../styles';
import { ActionItem } from '../models';
import { Glyphicon } from 'react-bootstrap';

interface IProps {
    description: string,
    count: number,
    isList: boolean,
    highlight?: string,
    color?: string,
    actionItem?: ActionItem,
    title?: string,
    onItemClick: (action: ActionItem) => void
}

export default (props: IProps) => {
    const handleItemClick = () => {
        if (props.count > 0) {
            props.onItemClick(props.actionItem);
        }
    };

    const backgroundColor = props.count == 0 ? "#ccc" : props.highlight;
    const border = props.count == 0 ? "1px solid #ccc" : "1px solid #a1a1a1";
    const color = props.color ? (props.count > 0 ? props.color : "white") : "white";
    const title = props.title != null ? props.title : "";

    return (
        <div style={{ display: "flex", alignItems: "center" }} title={title}>
            <div style={{ flexBasis: "11%", marginRight: 10, display: "flex", justifyContent: "center" }}>
                {props.isList ?
                    <BadgeWrapper style={{ backgroundColor, color, border }}>{props.count}</BadgeWrapper>
                    :
                    <BadgeWrapperForNonList style={{ backgroundColor, color, border }}><Glyphicon glyph='question-sign' /></BadgeWrapperForNonList>
                }
            </div>
            <ToDoItemDescriptionWrapper isDisabled={props.count == 0} onClick={handleItemClick}>
                {props.description}
            </ToDoItemDescriptionWrapper>
        </div>
    );
}
